import React, { useState } from 'react';
import { Link } from 'react-scroll';
import styles from './FirstScreen.module.css';
import natiImage from "../images/נתי ונטורה תמונה ראשית חדשה.webp";
import Loader from '../components/loader/Loader';
import { ChevronDown } from 'lucide-react';

const FirstScreen = () => {
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const handleImageError = () => {
    setImageLoaded(true);
  };

  if (!imageLoaded) {
    return (
      <>
        <Loader />
        <img
          src={natiImage}
          alt="נתי ונטורה אקדמיה"
          onLoad={handleImageLoad}
          onError={handleImageError}
          style={{ display: 'none' }}
        />
      </>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <div className={`${styles.backgroundImage} ${styles.leftImage}`}></div>
        <div className={`${styles.backgroundImage} ${styles.centerImage}`}></div>
        <div className={`${styles.backgroundImage} ${styles.rightImage}`}></div>
      </div>

      <div className={styles.topDescription}>
        לאחר אלפי לקוחות ועשור בתחום היופי, נתי ונטורה מציגה
      </div>

      <div className={styles.contentBox}>
        <div className={styles.title}>
          NATI VENTURA ACADEMY
        </div>
        <div className={styles.description}>
          האקדמיה שתפתח לך דלת לקריירה רווחית בעולם היופי
        </div>
        <Link
          to="קורסים"
          smooth={true}
          duration={1500}
          offset={-150}
          className={styles.arrowContainer}
        >
          <ChevronDown size={36} className={styles.bounceArrow} strokeWidth={1.5}/>
        </Link>
      </div>
    </div>
  );
};

export default FirstScreen;
